import { render, staticRenderFns } from "./theForm.html?vue&type=template&id=159e78e7&external"
import script from "./theForm.vue?vue&type=script&lang=js"
export * from "./theForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports